/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import { useDeleteRoleMutation } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
  onError: () => void;
};

export function useDeleteRole({ onSuccess, onError }: Props) {
  const [roleId, setRoleId] = useState("");

  const [deleteRoleMutation, { client, ...rest }] = useDeleteRoleMutation({
    onError: (error) => {
      showError(error.message);
      onError();
    },
    onCompleted: (data) => {
      if (data.removeRole) {
        onSuccess();
        showSuccess("Role has been removed.");
        removeFromApolloCache(client.cache, `Role:${roleId}`, "roles");
      }
    },
  });

  async function deleteRole(id: string) {
    setRoleId(id);
    await deleteRoleMutation({
      variables: {
        roleId: id,
      },
    });
  }

  return [deleteRole, { client, ...rest }] as const;
}
